"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const styles = exports.styles = {
  default: (color = '#f7f7f7') => /*#__PURE__*/(0, _react.css)("height:1px;background-color:", color, ";border:none;margin:1em 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  subtle: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.subtleText, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:subtle;")),
  margin: margin => /*#__PURE__*/(0, _react.css)("margin:", margin, " 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:margin;")),
  height: height => /*#__PURE__*/(0, _react.css)("height:", height, "px;" + (process.env.NODE_ENV === "production" ? "" : ";label:height;")),
  lightGray: process.env.NODE_ENV === "production" ? {
    name: "x74md2",
    styles: "background-color:#d7d7d7"
  } : {
    name: "1wi1qb-lightGray",
    styles: "background-color:#d7d7d7;label:lightGray;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
var _default = exports.default = styles;